let prefetchedFormDetails;

export const prefetchFormDetails = () => {
  if (!prefetchedFormDetails) {
    prefetchedFormDetails = import("layouts/formDetails");
  }
  return prefetchedFormDetails;
};
